<template>
    <div class="home__wrapper">
        <div class="home__slider">
            <MainSlider v-if="slides" type="homepage" :src="slides" />
        </div>
        <div class="home__sideCol">
            <div class="hp__login" v-if="!isAuth()">
                <div class="home__card">
                    <div
                        data-toggle="modal"
                        data-target="#registerModal"
                        class="btn btn--color-orange btn--width-full"
                    >
                        {{ this.getCaption("caption.register_button") }}
                    </div>
                    <router-link
                        :to="{ name: 'SignIn' }"
                        tag="div"
                        class="btn btn--color-purple btn--width-full"
                        >{{
                            this.getCaption("caption.login_button")
                        }}</router-link
                    >
                    <div class="d-flex justify-content-between mt-1">
                        <router-link
                            :to="{ name: 'ForgotPassword' }"
                            class="size-2 is-pointer"
                            >{{
                                this.getCaption("caption.forgot_password")
                            }}</router-link
                        >
                        <router-link to="/m/help" class="size-2 is-pointer">{{
                            this.getCaption("caption.help")
                        }}</router-link>
                    </div>
                </div>
            </div>

            <div class="hp__login" v-else>
                <div class="home__card pad-4">
                    <div class="text-center">
                        <p class="m-0 size-3">{{ userName }}</p>
                        <div class="welcome_desc">
                            <p class="size-2 m-0">
                                {{ getCaption("caption.welcome_desc_1") + " " }}
                                <router-link to="/m/card-detail">{{
                                    getCaption("caption.welcome_desc_2")
                                }}</router-link>
                                {{ " " + getCaption("caption.welcome_desc_3") }}
                            </p>
                        </div>
                    </div>
                    <router-link
                        :to="{ name: 'Logout' }"
                        tag="div"
                        class="btn btn--color-dark btn--width-full mb-0"
                        >{{
                            this.getCaption("caption.logout_button")
                        }}</router-link
                    >
                </div>
            </div>

            <div class="home__banner">
                <div class="home__card">
                    <div class="home__card-title">
                        <span>{{
                            this.getCaption("caption.advertisement")
                        }}</span>
                        <div class="slider__navbar">
                            <span class="slider__count banner__count"></span>
                            <i
                                class="slider__nav fas fa-chevron-left"
                                @click="changeBannerSlider('prev')"
                            ></i>
                            <i
                                class="slider__nav fas fa-chevron-right"
                                @click="changeBannerSlider('next')"
                            ></i>
                        </div>
                    </div>
                    <div class="home__card-divider"></div>
                    <div class="home__banner-slider">
                        <MainSlider
                            v-if="banners"
                            type="banner"
                            :src="banners"
                            @slideChange="setBannerSlideCount"
                            ref="bannerSlider"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="home__bottom">
            <router-link to="/m/card-detail" class="home__card">
                <div class="home__card-title">
                    <span>{{ getCaption("caption.card_reference") }}</span>
                </div>
                <div class="home__card-divider"></div>
                <div class="home__card-content">
                    <i class="fas fa-wallet"></i>
                    <span>{{ getCaption("caption.card_reference_body") }}</span>
                </div>
            </router-link>
            <router-link to="/m/card-register" class="home__card">
                <div class="home__card-title">
                    <span>{{ getCaption("caption.ebarimt") }}</span>
                </div>
                <div class="home__card-divider"></div>
                <div class="home__card-content">
                    <i class="fas fa-id-card"></i>
                    <span>{{ getCaption("caption.ebarimt_body") }}</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'BusTracker' }" class="home__card">
                <div class="home__card-title">
                    <span>{{ getCaption("caption.transport") }}</span>
                </div>
                <div class="home__card-divider"></div>
                <div class="home__card-content">
                    <i class="fas fa-business-time"></i>
                    <span>{{ getCaption("caption.transport_body") }}</span>
                </div>
            </router-link>

            <div class="home__card">
                <div class="home__card-title">
                    <span>{{ getCaption("caption.news") }}</span>
                    <div class="slider__navbar">
                        <span class="slider__count news__count">1 / 5</span>
                        <i
                            class="slider__nav fas fa-chevron-left"
                            @click="changeNewsSlider('prev')"
                        ></i>
                        <i
                            class="slider__nav fas fa-chevron-right"
                            @click="changeNewsSlider('next')"
                        ></i>
                    </div>
                </div>
                <div class="home__card-divider"></div>
                <div class="home__banner-slider">
                    <MainSlider
                        v-if="newsTitles"
                        type="news"
                        :src="newsTitles"
                        @slideChange="setNewsSlideCount"
                        ref="newsSlider"
                    />
                </div>
            </div>

            <!-- <router-link to="/m/news-feed" class="home__card">
        <div class="home__card-title">
          <span>{{ getCaption('caption.news') }}</span>
        </div>
        <div class="home__card-divider"></div>
        <div class="home__card-content">
          <i class="fas fa-newspaper"></i>
          <span>{{ getCaption("caption.news_body") }}</span>
        </div>
      </router-link>-->
        </div>

        <div class="u-modal" id="registerModal">
            <div class="u-modal__background"></div>
            <div class="u-modal__container">
                <div class="u-modal__header">
                    <!-- <div class="u-modal__title">Modal title</div> -->
                    <div class="u-modal__close">
                        <i class="fas fa-times"></i>
                    </div>
                </div>
                <div class="u-modal__body">
                    <strong
                        v-html="getCaption('caption.register_note_title')"
                    ></strong>
                    <div class="info__item">
                        <div>
                            <div class="info__text">
                                <div class="text-justify">
                                    {{
                                        this.getCaption(
                                            "caption.register_note_body1"
                                        )
                                    }}
                                </div>
                                <div class="text-justify">
                                    {{
                                        this.getCaption(
                                            "caption.register_note_body2"
                                        )
                                    }}
                                </div>
                                <span class="pad-4">{{
                                    this.getCaption(
                                        "caption.register_note_body3"
                                    )
                                }}</span>
                                <br />
                                <span class="pad-4">{{
                                    this.getCaption(
                                        "caption.register_note_body4"
                                    )
                                }}</span>
                                <br />
                                <span class="pad-4">{{
                                    this.getCaption(
                                        "caption.register_note_body5"
                                    )
                                }}</span>
                                <br />
                                <span class="pad-4">{{
                                    this.getCaption(
                                        "caption.register_note_body6"
                                    )
                                }}</span>
                                <br />
                                <div class="text-justify">
                                    {{
                                        this.getCaption(
                                            "caption.register_note_body7"
                                        )
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <router-link :to="{ name: 'SignUp' }">
                        <button
                            class="my-2 btn btn--color-orange btn--width-full rounded"
                        >
                            {{ this.getCaption("caption.register_button") }}
                        </button>
                    </router-link>
                </div>
            </div>
        </div>

        <div
            v-if="
                this.popup.isPublished == 'true' ||
                this.$route.query.popup_preview == 'true'
            "
            class="u-modal active"
            id="popupModal"
        >
            <div class="u-modal__background"></div>
            <div class="u-modal__container" style="max-height: initial">
                <div class="u-modal__header">
                    <div class="u-modal__title">{{ this.popup.title }}</div>
                    <div class="u-modal__close">
                        <i class="fas fa-times"></i>
                    </div>
                </div>
                <div class="u-modal__body" style="padding: 1em 0; width: 100%">
                    <img style="width: 100%" v-bind:src="popup.imageSrc" />
                    {{ this.popup.content }}
                </div>
                <div class="u-modal__footer">
                    <a
                        :href="this.popup.url"
                        target="_blank"
                        class="my-2 btn btn--color-orange btn--width-full rounded"
                        style="color: white"
                    >
                        {{ this.popup.buttontext }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MainSlider from "@/components/entry/MainSlider.vue";
import PageService from "@/services/PageService";
import { APP_NAME } from "@/env";

export default {
    components: {
        MainSlider,
    },

    data() {
        return {
            slides: null,
            banners: null,
            newsTitles: null,
            popup: null,
        };
    },

    computed: {
        userName() {
            if (this.$store.state.loggedUser) {
                return (
                    this.$store.state.loggedUser.firstName +
                    " " +
                    this.$store.state.loggedUser.lastName
                );
            } else {
                return null;
            }
        },
    },

    created() {
        this.$store.dispatch("setPageTitle", APP_NAME);
    },

    mounted() {
        this.getDesign();
        this.getBanner();
        this.getNewsTitles();
    },

    methods: {
        getBanner() {
            PageService.getBanner().then((response) => {
                if (response.data.success) {
                    let res = response.data.payload;
                    this.banners = res;
                }
            });
        },

        getDesign() {
            PageService.getDesign().then((response) => {
                const language = localStorage.getItem("language");

                if (response.data.success) {
                    let res = response.data.payload;
                    res.forEach((item) => {
                        if (item.name == "bg_color") {
                            let bgColors = eval(item.value);
                            this.$store.dispatch("setBgColors", bgColors);
                        } else if (item.name == "slide_images") {
                            // this.slides = eval(item.value);
                            this.slides = JSON.parse(item.value);
                        } else if (
                            item.name == "popup_eng" &&
                            language == "lang-eng"
                        ) {
                            this.popup = JSON.parse(item.value);
                        } else if (
                            item.name == "popup_mon" &&
                            language == "lang-mon"
                        ) {
                            this.popup = JSON.parse(item.value);
                        }
                    });
                }
            });

            $(window).on("load", function () {
                $("#registerModal").modal("show");
            });
        },

        setBannerSlideCount(slideData) {
            let slideNumber = slideData.slideNumber + 1;
            $(".banner__count").text(
                slideNumber + " / " + slideData.slideCount
            );
        },

        setNewsSlideCount(slideData) {
            let slideNumber = slideData.slideNumber + 1;
            $(".news__count").text(slideNumber + " / " + slideData.slideCount);
        },

        changeBannerSlider(direction) {
            if (direction == "prev") {
                this.$refs.bannerSlider.prev();
            } else if (direction == "next") {
                this.$refs.bannerSlider.next();
            }
        },

        changeNewsSlider(direction) {
            if (direction == "prev") {
                this.$refs.newsSlider.prev();
            } else if (direction == "next") {
                this.$refs.newsSlider.next();
            }
        },

        getNewsTitles() {
            PageService.getNewsTitles().then((res) => {
                if (res.data.success) {
                    let resArr = res.data.payload;
                    let arr = [];
                    let tempArr = [];
                    for (let i = 0; i < resArr.length; i++) {
                        tempArr.push(resArr[i]);
                        if (tempArr.length == 3) {
                            arr.push(tempArr);
                            tempArr = [];
                        }
                    }
                    this.newsTitles = arr;
                }
            });
        },
    },

    beforeRouteLeave(to, from, next) {
        $(".slick-slider").addClass("is-invisible");
        if ($(".slick-slider").hasClass("is-invisible")) {
            next();
        }
    },
};
</script>
